module.exports = __webpack_public_path__ + "static/media/Verified.f332ae82.svg";